import { render, staticRenderFns } from "./ERPRequest.vue?vue&type=template&id=1f3c1416&"
import script from "./ERPRequest.vue?vue&type=script&lang=js&"
export * from "./ERPRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports